import React, { Component } from 'react';
import { Container, Button, Form, FormGroup, Label, Input, FormFeedback, Row, Col, Card, Pagination, PaginationLink, PaginationItem } from 'reactstrap'
import Header from '../../Componentes/header'
import Nav from '../../Componentes/nav'
import Footer from '../../Componentes/footer'
import '../../CSS/bootstrap.min.css'
import '../../CSS/style.css'
import { toast } from 'react-toastify';
import Fetch from '../../Auxiliares/fetch'
import Tarjeta from '../../Componentes/Cards/consultaCard'
//import Tarjeta from '../../Componentes/Cards/estudianteCard'

//TERMINAR; agregar tabla hecha con cartas

export default class Consultar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            estudiantes: [],
            noControl: null,
            nombre: null,
            ap_paterno: null,
            ap_materno: null,
            carrera: null,
            semestre: null,
            currentPage: 1, //pagination
            elementsPerPage: 3, //pagination
        }
        this.handleClick = this.handleClick.bind(this);

        this.setValue = this.setValue.bind(this);
        this.setValueNumber = this.setValueNumber.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.borrar = this.borrar.bind(this);
        this.buscar = this.buscar.bind(this);
    }

    //pagination
    handleClick(event) {
        this.setState({
            currentPage: Number(event.target.id)
        });
    }
    //pagination 

    setValue(field, ev) {
        this.setState({ [field]: ev.target.value })
    }

    setValueNumber(field, ev) {
        this.setState({ [field]: Number(ev.target.value) })
    }

    handleKeyPress = e => {
        if (e.key === "Enter") {
            this.buscar();
        }
    }

    buscar() {

        const { nombre, ap_paterno, ap_materno, noControl, carrera, semestre } = this.state

        Fetch('/api/consultar', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ nombre, ap_paterno, ap_materno, noControl, carrera, semestre })
        })
            .then(response => {
                this.setState({ estudiantes: response.data })
                this.setState({currentPage: 1})
            })
            .catch(err => {
                switch (err.status) {
                    case 600:
                        toast.error('Datos no encontrados')
                        break;
                    case 605:
                        toast.info('No existen coincidencias')
                        break;
                    default:
                        toast.error("Se produjo un error de conexion")
                        break;
                }
            })

    }

    borrar() {
        this.setState({
            noControl: '',
            nombre: '',
            ap_paterno: '',
            ap_materno: '',
            carrera: '',
            semestre: '',
        })
    }



    render() {

        //pagination
        const { estudiantes, currentPage, elementsPerPage } = this.state;

        const indexOfLastTodo = currentPage * elementsPerPage;
        const indexOfFirstTodo = indexOfLastTodo - elementsPerPage;
        const currentStudents = estudiantes.slice(indexOfFirstTodo, indexOfLastTodo);

        const pageNumbers = [];
        for (let i = 1; i <= Math.ceil(estudiantes.length / elementsPerPage); i++) {
            pageNumbers.push(i);
        }
        //pagination

        /*const renderPageNumbers = pageNumbers.map(number => {
          return (
            <Pagination aria-label="Page navigation example">
            <PaginationItem>
                <PaginationLink
                              key={number}
                              id={number}
                              onClick={this.handleClick}>
                    {number}
                </PaginationLink>
            </PaginationItem>
            </Pagination>
          );
        });*/

        return (
            <html>
                <Header />
                <Row>
                    <Col className="bg-light" lg="3">
                        <Nav usuario={sessionStorage.getItem('usuario')} tipo={sessionStorage.getItem('rol')} />
                    </Col>

                    <Col className="bg-light" lg="9">
                        <div id="">
                            <div class="container-fluid">
                                <h1 class="text-center">Consultar</h1>
                                <div className="p-4">
                                    <Container>
                                        <Card className="p-4">
                                            <Form>
                                                <Row>
                                                    <Col md="4" xs="12">
                                                        <FormGroup>
                                                            <Label>Nombre</Label>
                                                            <Input type="text" name="nombre" className="col-12" onChange={this.setValue.bind(this, "nombre")} onKeyPress={this.handleKeyPress} value={this.state.nombre} />
                                                        </FormGroup>
                                                    </Col>

                                                    <Col md="4" xs="12">
                                                        <FormGroup>
                                                            <Label>Apellido Paterno</Label>
                                                            <Input type="text" name="paterno" className="col-12" onChange={this.setValue.bind(this, "ap_paterno")} onKeyPress={this.handleKeyPress} value={this.state.ap_paterno} />
                                                        </FormGroup>
                                                    </Col>

                                                    <Col md="4" xs="12">
                                                        <FormGroup>
                                                            <Label>Apellido Materno</Label>
                                                            <Input type="text" name="materno" className="col-12" onChange={this.setValue.bind(this, "ap_materno")} onKeyPress={this.handleKeyPress} value={this.state.ap_materno} />
                                                        </FormGroup>
                                                    </Col>
                                                </Row>


                                                <Row>
                                                    <Col xs="8">
                                                        <FormGroup>
                                                            <Label>No. Control</Label>
                                                            <Input type="text" name="noControl" className="col-12" onChange={this.setValueNumber.bind(this, "noControl")} onKeyPress={this.handleKeyPress} maxLength="8" value={this.state.noControl} />
                                                            <FormFeedback></FormFeedback>
                                                        </FormGroup>
                                                    </Col>

                                                    <Col xs="4">
                                                        <FormGroup style={{ widht: '100%' }}>
                                                            <Label>Semestre</Label>
                                                            <Input type="select" name="semestre" className="col-12" onChange={this.setValue.bind(this, "semestre")} onKeyPress={this.handleKeyPress} value={this.state.semestre}>
                                                                <option></option>
                                                                <option>1</option>
                                                                <option>2</option>
                                                                <option>3</option>
                                                                <option>4</option>
                                                                <option>5</option>
                                                                <option>6</option>
                                                                <option>7</option>
                                                                <option>8</option>
                                                                <option>9</option>
                                                                <option>10</option>
                                                                <option>11</option>
                                                                <option>12</option>
                                                            </Input>
                                                        </FormGroup>
                                                    </Col>


                                                    <Col xs="12">
                                                        <FormGroup>
                                                            <Label>Carrera</Label>
                                                            <Input type="select" name="carrera" className="col-12" onChange={this.setValue.bind(this, "carrera")} onKeyPress={this.handleKeyPress} value={this.state.carrera}>
                                                                <option ></option>
                                                                <option>Ingenieria en sistemas computacionales</option>
                                                                <option>Ingenieria industrial</option>
                                                                <option>Ingenieria en logistica</option>
                                                                <option>Ingenieria en mecatronica</option>
                                                                <option>Ingenieria en mecánica</option>
                                                                <option>Ingenieria en gestion</option>
                                                                <option>Ingenieria en energias Renovables</option>
                                                                <option>Ingenieria en electronica</option>
                                                                <option>Ingenieria en quimica</option>
                                                                <option>Ingenieria en eléctrica</option>
                                                                <option>Licenciatura en contabilidad</option>
                                                            </Input>
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                            </Form>

                                            <Row>
                                                <Col xs="6">
                                                    <Button className="bg-info mt-1 mb-1" onClick={this.buscar} block>Buscar</Button>
                                                </Col>
                                                <Col xs="6">
                                                    <Button className="bg-dark mt-1 mb-1" onClick={this.borrar} block>Limpiar</Button>
                                                </Col>
                                            </Row>
                                        </Card>

                                        <Row className="mt-3">
                                            <Tarjeta encabezado={true} />
                                            {currentStudents.length > 0 ? currentStudents.map((index) => (<Tarjeta id={index._id} noControl={index.noControl} nombre={index.nombre} ap_paterno={index.ap_paterno} ap_materno={index.ap_materno} carrera={index.carrera} semestre={index.semestre} />)) : <Col><Card className="d-flex p-5 text-center bg-secondary text-light shadow " style={{ border: 'dashed 2px' }} >Lista vacia</Card></Col>
                                            }
                                            {/*this.state.estudiantes.length > 0 ? this.state.estudiantes.map((index) => (<Tarjeta id={index._id} noControl={index.noControl} nombre={index.nombre} ap_paterno={index.ap_paterno} ap_materno={index.ap_materno} carrera={index.carrera} semestre={index.semestre} />)) : <Col><Card className="d-flex p-5 text-center bg-secondary text-light shadow " style={{ border: 'dashed 2px' }} >Lista vacia</Card></Col>
                                            */}
                                            {/*renderPageNumbers*/}
                                        </Row>
                                        <nav aria-label="Page navigation example"> 
                                            <ul class="pagination flex-wrap" style={{
                                                display: 'flex', justifyContent:'center', alignItems:'center', cursor: 'pointer'}}>
                                                {pageNumbers.map((number) => (
                                                    <li style={{display: 'inline-block', width: '50px', textAlign: 'center' }}
                                                            className={number == this.state.currentPage ? "page-item active": "page-item"}>
                                                                <a class="page-link"
                                                                    key={number}
                                                                    id={number}
                                                                    onClick={this.handleClick}
                                                                    >
                                                                    {number}
                                                                </a>
                                                </li>))}
                                            </ul>
                                        </nav>
                                    </Container>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Footer />
            </html>
        )
    }
}
